export default __webpack_public_path__ + "static/media/ChickenIcon.0e01161e.svg";